import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { StoreProvider } from './store';
import ErrorBoundaries from '@components/ErrorBoundaries/ErrorBoundaries';
import { TranslationProvider } from 'react-auto-google-translate';

// Set default language về 'vi'
const ORIGINAL_LANG = 'vi';
const googtransMatch = document.cookie.match('(^|;) ?googtrans=([^;]*)(;|$)');
if (!googtransMatch) {
  document.cookie = `googtrans=/auto/${ORIGINAL_LANG}; path=/; max-age=31536000`; // 1 năm
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ErrorBoundaries>
    <TranslationProvider originalLang="vi">
      <StoreProvider>
        <App />
      </StoreProvider>
    </TranslationProvider>
  </ErrorBoundaries>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
